import type {
  Attendance,
  Diet,
  GuestCircle,
  PaymentMethod,
  Role,
  SupplierStatus,
  TaskPriority,
} from '@/mock/types'

export const roleLabels: Record<Role, string> = {
  owner: 'Správce',
  editor: 'Editor',
  viewer: 'Pouze čtení',
}

export const priorityLabels: Record<TaskPriority, string> = {
  low: 'Nízká',
  normal: 'Běžná',
  high: 'Vysoká',
}

export const dietLabels: Record<Diet, string> = {
  vegetarian: 'Vegetariánské',
  vegan: 'Veganské',
  'lactose-free': 'Bez laktózy',
  'gluten-free': 'Bez lepku',
}

export const attendanceLabels: Record<Attendance, string> = {
  invited: 'Pozván',
  waiting: 'Čeká na odpověď',
  confirmed: 'Potvrzeno',
  declined: 'Nepřijde',
}

export const circleLabels: Record<GuestCircle, string> = {
  bride: 'Nevěsta',
  groom: 'Ženich',
  shared: 'Společní',
}

export const supplierStatusLabels: Record<SupplierStatus, string> = {
  inquiry: 'Poptáváme',
  agreed: 'Domluveno',
  booked: 'Podepsáno',
  cancelled: 'Zrušeno',
}

export function supplierStatusTone(status: SupplierStatus) {
  if (status === 'booked') return 'success' as const
  if (status === 'agreed') return 'accent' as const
  return 'neutral' as const
}

export const supplierCategoryLabels: Record<string, string> = {
  venue: 'Místo',
  catering: 'Catering',
  bar: 'Bar',
  'cake-sweets': 'Dorty a sladkosti',
  photographer: 'Fotograf',
  videographer: 'Kameraman',
  florist: 'Floristika',
  decor: 'Dekorace',
  stationery: 'Tiskoviny',
  'ceremony-music': 'Hudba k obřadu',
  'party-music': 'Hudba na hostinu',
  moderator: 'Moderátor',
  officiant: 'Oddávající',
  hair: 'Kadeřnictví',
  makeup: 'Vizážistika',
  'bride-attire': 'Šaty pro nevěstu',
  'groom-attire': 'Oblek pro ženicha',
  rings: 'Prsteny',
  rentals: 'Pronájem vybavení',
  transport: 'Doprava',
  accommodation: 'Ubytování',
  coordination: 'Koordinace',
  entertainment: 'Zábava',
  other: 'Ostatní',
}

export const paymentMethodLabels: Record<PaymentMethod, string> = {
  transfer: 'Převodem',
  cash: 'Hotově',
  card: 'Kartou',
}
